// Vehicle Vietnamese translations
export const vehicleVi = {
  'add.vehicle': 'Thêm Phương Tiện',
  'add.vehicle.capacity': 'Thêm Trọng Tải Phương Tiện',
  'all.vehicles': 'Tất Cả Phương Tiện',
  'all.vehicles.efficiency': 'Hiệu Suất Tất Cả Phương Tiện',
  'capacity.tons': 'Trọng Tải (tấn)',
  'edit.vehicle': 'Chỉnh Sửa Phương Tiện',
  'error.creating.vehicle': 'Lỗi khi tạo phương tiện',
  'error.deleting.vehicle': 'Lỗi khi xóa phương tiện',
  'error.updating.vehicle': 'Lỗi khi cập nhật phương tiện',
  'failed.to.load.vehicles': 'Không thể tải danh sách phương tiện',
  'fees.auto.calculated.based.on.vehicle.capacity.and.destination': 'Phí được tính tự động dựa trên trọng tải xe và điểm đến',
  'license.plate': 'Biển Số Xe',
  'license.plate.alphanumeric.only': 'Biển số xe chỉ được chứa chữ cái và số',
  'manage.capacity.tons': 'Quản Lý Trọng Tải',
  'no.synced.vehicles': 'Không có phương tiện nào được đồng bộ với VCOMSAT',
  'no.synced.vehicles.hint': 'Không có phương tiện nào được đồng bộ với VCOMSAT. Vui lòng đồng bộ phương tiện từ trang Phương Tiện.',
  'please.select.vehicle': 'Vui lòng chọn phương tiện trước',
  'preferred.vehicle': 'Phương Tiện Ưa Thích',
  'select.capacity': 'Chọn trọng tải',
  'select.vehicle': 'Chọn phương tiện',
  'total.vehicles': 'Tổng Số Phương Tiện',
  'tracked.vehicles': 'Phương Tiện Được Theo Dõi',
  'truck': 'Xe Tải',
  'truck.detailed.report': 'Báo Cáo Chi Tiết Xe Tải',
  'truck.number': 'Số Xe',
  'vcomsat.sync.vehicles': 'Đồng Bộ với VCOMSAT',
  'vcomsat.total.vehicles': 'Tổng Số Xe VCOMSAT',
  'vehicle': 'Xe',
  'vehicle.capacity': 'Dung Tích Xe',
  'vehicle.capacity.optional': 'Trọng Tải Xe (Tùy Chọn)',
  'vehicle.capacity.tons': 'Tải Trọng Phương Tiện',
  'vehicle.capacity.tons.management': 'Quản Lý Trọng Tải Phương Tiện',
  'vehicle.created.successfully': 'Tạo phương tiện thành công',
  'vehicle.deleted.successfully': 'Xóa phương tiện thành công',
  'vehicle.details': 'Chi Tiết Phương Tiện',
  'vehicle.list': 'Danh Sách Phương Tiện',
  'vehicle.management': 'Quản Lý Phương Tiện',
  'vehicle.not.synced.with.vcomsat': 'Không Có Xe Đã Đồng Bộ',
  'vehicle.tracking': 'Theo Dõi Phương Tiện',
  'vehicle.updated.successfully': 'Cập nhật phương tiện thành công',
  'vehicles': 'Phương Tiện',
  'traffic.signs.not.available': 'Biển báo không khả dụng (kiểm tra data.wmap.update)',
  'traffic.signs.hide': 'Ẩn biển báo',
  'traffic.signs.show': 'Hiện biển báo',
  'traffic.signs.hide.full': 'Ẩn biển báo giao thông',
  'traffic.signs.show.full': 'Hiện biển báo giao thông',
  'traffic.signs': 'Biển báo',
  'traffic.signs.full': 'Biển báo giao thông',
  'traffic.signs.legend.speed.limit': 'Tốc độ',
  'traffic.signs.legend.camera': 'Camera',
  'traffic.signs.legend.other': 'Khác',
};
